import { refreshCustomerBenefitsAtom } from './../atoms/refreshCustomerBenefitsAtom';
import { OnlineSales } from 'gw-edge-client';
import { selector } from 'recoil';
import type { CustomerBenefitsDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { isLoggedOnSelector } from './isLoggedOnSelector';

export const customerBenefitsSelector = selector<CustomerBenefitsDTO>({
    key: 'customerBenefitsSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        const isLoggedOn = get(isLoggedOnSelector);
        get(refreshCustomerBenefitsAtom);
        if (!isLoggedOn) return {};
        if (!jobNumber) throw new Error('Invalid jobId');
        if (!sessionId) throw new Error('Invalid sessionId');
        return await OnlineSales.getCustomerBenefits(jobNumber, sessionId);
    }
});
